<template>
  <div class="home_wrap">
    <van-nav-bar
      title="Registros de plataforma"
      left-text=""
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <van-tabs
      v-model="nav_active"
      :background="'transparent'"
      :color="'#fff'"
      @change="tabChange"
      shrink
    >
      <van-tab title="">
        <template #title>
          <div class="nav_title">
            <span class="ppl">Lista De Retirada</span>
          </div>
        </template>
        <div class="select_items">
          <div class="select_item">
            <select
              id="withdraw"
              name="withdraw"
              class="amount-input selectpix"
              v-model="select_withdraw_time"
              @change="selectWithdrawTimeChange"
            >
              <option value="today" :selected="select_withdraw_time == 'today'">
                Hoje
              </option>
              <option
                value="yesterday"
                :selected="select_withdraw_time == 'yesterday'"
              >
                Ontem
              </option>
              <option value="last7" :selected="select_withdraw_time == 'last7'">
                Últimos 7 Dias
              </option>
              <option
                value="last15"
                :selected="select_withdraw_time == 'last15'"
              >
                Últimos 15 Dias
              </option>
              <option
                value="last30"
                :selected="select_withdraw_time == 'last30'"
              >
                Últimos 30 Dias
              </option>
            </select>
          </div>
          <div class="select_item">
            <select
              id="type"
              name="type"
              class="amount-input selectpix"
              v-model="select_withdraw_type"
              @change="selectWithdrawTypeChange"
            >
              <option value="all" :selected="select_withdraw_type == 'all'">
                Todos
              </option>
              <option value="0" :selected="select_withdraw_type == '0'">
                {{ $t("审核中") }}
              </option>
              <option value="1" :selected="select_withdraw_type == '1'">
                {{ $t("已打款") }}
              </option>
              <option value="2" :selected="select_withdraw_type == '2'">
                {{ $t("拒绝") }}
              </option>
              <option value="3" :selected="select_withdraw_type == '3'">
                {{ $t("失败") }}
              </option>
              <option value="4" :selected="select_withdraw_type == '4'">
                Pagamento em andamento
              </option>
              <option value="5" :selected="select_withdraw_type == '5'">
                Anormal
              </option>
            </select>
          </div>
        </div>
        <div
          v-for="(item, k) in withDrawList.list"
          :key="k"
          class="recharge-one"
        >
          <div class="order-status">
            <div>Pagamento online</div>
            <div class="mmm">{{ item.money }}</div>
          </div>
          <div class="money3">
            <div class="order">
              {{ item.time }}
            </div>
            <div>
              <div v-if="item.status == 0" class="unpay1">
                <b>{{ $t("审核中") }}</b>
              </div>
              <div v-if="item.status == 1" class="unpay1">
                <b>{{ $t("已打款") }}</b>
              </div>
              <div v-if="item.status == 2" class="unpay1">
                <b>{{ $t("拒绝") }}</b>
              </div>
              <div v-if="item.status == 3" class="unpay1">
                <b>{{ $t("失败") }}</b>
              </div>
              <div v-if="item.status == 4" class="unpay1">
                <b>{{ $t("打款中") }}</b>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="">
        <template #title>
          <div class="nav_title">
            <span class="ppl">Lista De Depósito</span>
          </div>
        </template>
        <div class="select_items">
          <div class="select_item">
            <select
              id="withdraw"
              name="withdraw"
              class="amount-input selectpix"
              v-model="select_deposit_time"
              @change="selectDepositTimeChange"
            >
              <option value="today" :selected="select_deposit_time == 'today'">
                Hoje
              </option>
              <option
                value="yesterday"
                :selected="select_deposit_time == 'yesterday'"
              >
                Ontem
              </option>
              <option value="last7" :selected="select_deposit_time == 'last7'">
                Últimos 7 Dias
              </option>
              <option
                value="last15"
                :selected="select_deposit_time == 'last15'"
              >
                Últimos 15 Dias
              </option>
              <option
                value="last30"
                :selected="select_deposit_time == 'last30'"
              >
                Últimos 30 Dias
              </option>
            </select>
          </div>
          <div class="select_item">
            <select
              id="type"
              name="type"
              class="amount-input selectpix"
              v-model="select_deposit_type"
              @change="selectDepositTypeChange"
            >
              <option value="all" :selected="select_deposit_type == 'all'">
                Todos
              </option>
              <option value="1" :selected="select_deposit_type == '1'">
                Já pago
              </option>
              <option value="0" :selected="select_deposit_type == '0'">
                não pago
              </option>
            </select>
          </div>
        </div>
        <div v-for="(item, k) in re_list.list" :key="k" class="recharge-one">
          <div class="order-status">
            <div>Pagamento online</div>
            <div class="mmm">{{ item.money }}</div>
          </div>
          <div class="money3">
            <div class="order">
              {{ item.time }}
            </div>
            <div :class="item.status == 1 ? 'status' : 'unpay'">
              <b v-if="item.status == 1">{{ $t("已付款") }}</b>
              <b v-else>{{ $t("未付款") }}</b>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="">
        <template #title>
          <div class="nav_title">
            <span class="ppl">Ordem</span>
          </div>
        </template>
        <div class="select_items">
          <div class="select_item">
            <select
              id="game"
              name="game"
              class="amount-input selectpix"
              v-model="select_gameRecord_time"
              @change="selectGameRecordChange"
            >
              <option
                value="today"
                :selected="select_gameRecord_time == 'today'"
              >
                Hoje
              </option>
              <option
                value="yesterday"
                :selected="select_gameRecord_time == 'yesterday'"
              >
                Ontem
              </option>
              <option
                value="last7"
                :selected="select_gameRecord_time == 'last7'"
              >
                Últimos 7 Dias
              </option>
              <option
                value="last15"
                :selected="select_gameRecord_time == 'last15'"
              >
                Últimos 15 Dias
              </option>
              <option
                value="last30"
                :selected="select_gameRecord_time == 'last30'"
              >
                Últimos 30 Dias
              </option>
            </select>
          </div>
          <div class="select_item">
            <select
              id="gameType"
              name="gameType"
              class="amount-input selectpix"
              v-model="select_gameRecord_type"
              @change="selectGameRecordType"
            >
              <option value="pg" :selected="select_gameRecord_type == 'pg'">
                PG
              </option>
              <option value="pp" :selected="select_gameRecord_type == 'pp'">
                PP
              </option>
              <option value="jdb" :selected="select_gameRecord_type == 'jdb'">
                JDB
              </option>
              <option value="tada" :selected="select_gameRecord_type == 'tada'">
                TADA
              </option>
            </select>
          </div>
        </div>
        <!-- <gameRecord></gameRecord> -->
        <div
          class="game_items"
          v-for="(item, index) in game_record"
          v-show="index < max_show"
          :key="index"
        >
          <div class="game_item">
            <div class="game_one">
              <span class="game_name">{{ item.game_name }}</span>
              <span class="game_amount">
                Apostas válidas R$ {{ item.bet_amount }}</span
              >
              <span class="game_amount" v-if="item.win_amount == '0.00'">
                <span>Ganhos e Perdas</span>
                <span class="lose">-R$ {{ item.bet_amount }}</span>
              </span>
              <span class="game_amount" v-else>
                <span>Ganhos e Perdas</span>
                <span class="win">R$ {{ item.win_amount }}</span>
              </span>
            </div>
            <div class="game_two">
              <span class="game_time">{{ item.createtime }}</span>
              <span class="game_id"
                >Número da Nota {{ item.transaction_id.split("-")[0] }}</span
              >
              <div class="order_no" @click="doCopy(item.transaction_id)">
                <img src="../../assets/images/share/copy_h.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div
          class="show_more"
          v-show="game_record.length > max_show"
          @click="max_show += max_show"
        >
          Mostre mais ⇊
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import Vue from "vue";
import { Tabs, Tab, NavBar } from "vant";
import Fetch from "../../utils/fetch";
import gameRecord from "../game/gameRecord.vue";
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(NavBar);
export default {
  name: "record",
  components: {
    gameRecord,
  },
  data() {
    return {
      nav_active: 0,
      select_withdraw_time: "today",
      select_withdraw_type: "all",
      select_deposit_time: "today",
      select_deposit_type: "all",
      select_gameRecord_time: "today",
      select_gameRecord_type: "pg",
      re_list: [],
      game_record: [],
      withDrawList: [],
      max_show: 10,
    };
  },
  created() {
    console.log(this.$route.query, "传参");
    if (this.$route.query.tab) {
      this.nav_active = this.$route.query.tab;
      this.tabChange(this.nav_active);
    } else {
      this.tabChange(this.nav_active);
    }
  },
  mounted() {},
  methods: {
    tabChange(v) {
      this.nav_active = v;
      if (this.nav_active == 0) {
        Fetch("/withdrow/getwithdrawbydate", {
          type: this.select_withdraw_time,
          status: this.select_withdraw_type,
        }).then((r) => {
          //console.log(r);
          if (r.data) {
            this.withDrawList = r.data;
          }
        });
      }
      if (this.nav_active == 1) {
        Fetch("/recharge/getrechargebydate", {
          status: this.select_deposit_type,
          type: this.select_deposit_time,
        }).then((r) => {
          //console.log(r);
          if (r.data) {
            this.re_list = r.data;
          }
        });
      }
      if (this.nav_active == 2) {
        this.getRecord("betRecord");
      }
    },
    selectWithdrawTimeChange() {
      this.withDrawList = [];
      Fetch("/withdrow/getwithdrawbydate", {
        type: this.select_withdraw_time,
        status: this.select_withdraw_type,
      }).then((r) => {
        //console.log(r);
        if (r.data) {
          this.withDrawList = r.data;
        }
      });
    },
    selectWithdrawTypeChange() {
      this.withDrawList = [];
      Fetch("/withdrow/getwithdrawbydate", {
        type: this.select_withdraw_time,
        status: this.select_withdraw_type,
      }).then((r) => {
        //console.log(r);
        if (r.data) {
          this.withDrawList = r.data;
        }
      });
    },
    selectDepositTimeChange() {
      this.re_list = [];
      Fetch("/recharge/getrechargebydate", {
        status: this.select_deposit_type,
        type: this.select_deposit_time,
      }).then((r) => {
        //console.log(r);
        if (r.data) {
          this.re_list = r.data;
        }
      });
    },
    selectDepositTypeChange() {
      this.re_list = [];
      Fetch("/recharge/getrechargebydate", {
        status: this.select_deposit_type,
        type: this.select_deposit_time,
      }).then((r) => {
        //console.log(r);
        if (r.data) {
          this.re_list = r.data;
        }
      });
    },
    onClickLeft() {
      this.$router.push("/person");
    },
    getRecord(game_type) {
      Fetch("/record/getRecord", {
        type: this.select_gameRecord_time,
        game: this.select_gameRecord_type,
      }).then((r) => {
        if (r.data) {
          this.game_record = r.data;
        }
      });
    },
    doCopy(val) {
      let _this = this;
      let value = val.split()[0];
      this.$copyText(String(value)).then(function (e) {
        _this.$toast({
          background: "#07c160",
          message: _this.$t("复制成功"),
        });
      });
    },
    selectGameRecordType() {
      this.game_record = [];
      this.max_show = 10;
      this.getRecord();
    },
    selectGameRecordChange() {
      this.game_record = [];
      this.max_show = 10;
      this.getRecord();
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/variables.less";
/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}
.home_wrap {
  width: 100%;
  min-height: 100vh;
  //background-color: rgb(48, 48, 48);
  padding-bottom: 1.8rem;
  // padding-top: 1.5rem;
}
/deep/ .van-tabs__wrap {
  border-bottom: 0.01rem solid @bodercolor;
  background-color: @secondary-color;
}
/deep/ .nav_title span {
  color: #fff;
  font-size: 0.3rem;
}
select {
  border-radius: 0.5rem;
  color: #fff;
  background-color: @secondary-color;
  padding: 0.1rem 0.2rem;
  border: 0.01rem solid @bodercolor;
  color: #ccc;
  font-size: 0.3rem;
  // padding-right: .4rem;
  // appearance: none;
  // -moz-appearance: none;
  // -webkit-appearance: none;
}
.select_items {
  display: flex;
  justify-content: space-around;
  padding-top: 0.2rem;
  padding-bottom: 0.4rem;
}
.home_wrap {
  width: 100%;
  min-height: 100vh;
  //background-color: rgb(48, 48, 48);
  padding-bottom: 1.8rem;
  padding-top: 1.2rem;
}
.order_no {
  img {
    width: 0.3rem;
  }
}
.game_items {
  width: 100%;
  .game_item {
    width: 90%;
    margin: 0 auto 0.3rem auto;
    border-radius: 0.21053rem;
    color: #fff;
    overflow: hidden;
    position: relative;
    background: @activityColor;
    padding: 0 0;
    font-size: 0.25rem;
    .game_one {
      display: flex;
      justify-content: space-between;
      padding: 0.3rem;
      .game_name {
        color: #fff;
      }
    }
    .game_two {
      display: flex;
      justify-content: space-between;
      padding: 0.3rem;
    }
  }
}
.game_amount > span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
}
.lose {
  color: #ad0000;
  margin-left: 0.2rem;
}
.win {
  color: #04f702;
  margin-left: 0.2rem;
}
.game_amount {
  color: #fff;
}
.game_time {
  color: #fff;
}
.game_id {
  color: #fff;
}
.tpng {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.bpng {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.myteam-bg {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.showmore {
  height: 30px;
  line-height: 30px;
  cursor: pointer;
}

.ct-time2 {
  padding: 0.2rem 15px;
  font-size: 0.34rem;
  display: flex;
  justify-content: space-between;
}

.ct-time {
  padding: 3px 15px;
  font-size: 0.34rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.is_active {
  padding: 15px 15px;
  font-size: 0.34rem;
  line-height: 16px;
  // display: flex;
  justify-content: space-between;
}

.mdec {
  margin-top: 10px;
  width: 100%;
  color: #fff;
}

.mmm {
  //   width: 100%;
  font-weight: 700;
  color: gold;
}
.show_more {
  color: #fff;
  width: 95%;
  margin: 0.3rem auto;
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.35rem;
}
.m-1 {
  width: 33.33%;
  padding: 0;
  text-align: center;
}

.m-1:nth-child(1) {
  border-right: 1px solid #e5e5e5;
}

.m-1:nth-child(2) {
  border-right: 1px solid #e5e5e5;
}

.money3 {
  //   width: 95%;
  margin: 0 auto;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fff;
  //border-bottom: thin solid rgba(126, 126, 126, 0.1);
}

.order {
  font-size: 0.3rem;
}
select#gameType {
  width: 3rem;
}
.status {
  // width: 60px;
  //   padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  //background: linear-gradient(to right, rgb(166, 0, 146), rgb(97, 17, 207));
}

.unpay,
.unpay1,
.unpay2,
.unpay3,
.unpay4 {
  // width: 60px;
  //   padding: 0 15px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  color: #fc661e;
  //background:  linear-gradient(90deg, #3FBBFE 0%, #A541FF 100%);
}

.order-status {
  width: 100%;
  box-sizing: border-box;
  //   padding: 0.1rem 0 0.1rem 15px;
  padding: 0.26316rem 0.26316rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  //   border-bottom: thin solid #e5e5e5;
}

.recharge-one {
  width: 90%;
  margin: 0 auto 0.3rem auto;
  border-radius: 8px;
  color: #fff;
  overflow: hidden;
  position: relative;
  //border: 1px solid #895DB3;
  background: @activityColor;
  padding: 0 0;
  font-size: 0.3rem;
}

.basic_wrap {
  margin-top: 0;
  padding-top: 1.8rem;
  position: relative;
}
</style>